export default __webpack_public_path__ + "static/media/guidepost.2e3bc672.png";